import React from "react";
import { LANDING } from "@/constants/testIds";

const Footer = () => {
  return (
    <footer
      data-testid={LANDING.footer}
      className="px-6 md:px-12 pb-12 pt-8"
    >
      <div className="max-w-7xl mx-auto border-t border-black/10 pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2">
            <span className="text-xl">🏀</span>
            <span className="font-black tracking-tight text-lg">Haus of Chi</span>
          </div>
          <p className="mt-2 text-sm text-zinc-500 max-w-md leading-relaxed">
            San Antonio, Texas — Helping local businesses turn visibility into revenue.
          </p>
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-400">
          © {new Date().getFullYear()} Haus of Chi
        </div>
      </div>
    </footer>
  );
};

export default Footer;
